/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DistributionTypeEnum {
    Acc = 'Acc',
    Dist = 'Dist'
}

export function DistributionTypeEnumFromJSON(json: any): DistributionTypeEnum {
    return DistributionTypeEnumFromJSONTyped(json, false);
}

export function DistributionTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionTypeEnum {
    return json as DistributionTypeEnum;
}

export function DistributionTypeEnumToJSON(value?: DistributionTypeEnum | null): any {
    return value as any;
}

